import { BaseField } from './BaseField';

const imgFloorIcon = "/assets/floor-icon.svg";

export class FloorLevelsField extends BaseField {
  constructor() {
    super({
      key: 'floor_levels',
      icon: imgFloorIcon,
      defaultLabel: 'Kondygnacje'
    });
  }

  renderForList(property) {
    return this.renderFloorLevels(property);
  }

  renderForCard(property) {
    return this.renderFloorLevels(property);
  }

  renderFloorLevels(property) {
    const floorLevels = property.floor_levels;

    if (!floorLevels) {
      return {
        label: this.defaultLabel,
        value: ''
      };
    }

    return {
      label: this.defaultLabel,
      value: floorLevels
    };
  }
}
